module.exports = __webpack_public_path__ + "static/plitafoundation-9a9bd5afdf72036345ae33940d214a77.jpg";